/*
  Module configuration file
 */
import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {ModuleConfiguration} from "../core/config/module-configuration";
import {TopicConfiguration} from "./topic-configuration";
import {FeatureLayerConfiguration} from "../core/config/layer-configuration";
import {PopupConfiguration} from "../core/config/popup-configuration";
import {LegendConfiguration} from "./legend-configuration";
import {SidebarConfiguration} from "./sidebar-configuration";
import {LayerListConfiguration} from "../core/config/layer-list-configuration";
import {WebMapConfiguration} from "../core/config/web-map-configuration";
import {
    FillSymbolConfiguration,
    PictureMarkerSymbolConfiguration
} from "../core/config/symbol-configuration";
import {MaintenanceConfiguration} from "../core/config/maintenance-configuration";
import {NavigationConfiguration} from "./navigation-configuration";
import {PrintConfiguration} from "../core/config/print-configuration";
import {MessageConfiguration} from "../core/config/message-configuration";
import {LinkConfiguration} from "../core/config/link-configuration";
import {ToolsConfiguration} from "../core/config/tools-configuration";
import {BookmarkConfiguration} from "../core/config/bookmark-configuration";
import {TopicSwitcherConfiguration} from "../core/config/topic-switcher-configuration";
import { SearchConfiguration } from "../core/config/search-configuration";


@JsonObject()
export class WebMapMetaConfiguration extends ModuleConfiguration {
    @JsonProperty()
    declare alerts?: MessageConfiguration[];
    @JsonProperty()
    declare startupMessage?: MessageConfiguration;

    constructor() {
        super();
    }
}
@JsonObject()
export class TrackerConfiguration {
    @JsonProperty()
    declare urlBase: string;
    @JsonProperty()
    declare siteId: number;
    constructor() {
    }
}
@JsonObject()
export class MapViewerConfiguration extends ModuleConfiguration {
    @JsonProperty()
    declare bookmarks: BookmarkConfiguration[];

    @JsonProperty()
    declare breakpoints: {
        [key: string]: number;
    };
    // the topic activated on application's start
    @JsonProperty()
    declare initialTopic: string;

    /**
     * Layer list configuration
     */
    @JsonProperty()
    declare layerList: LayerListConfiguration;

    /**
     * Layer configurations (e.g. station layer)
     */
    @JsonProperty()
    declare layers: FeatureLayerConfiguration[];

    /**
     * "über diese Karte" Link
     */
    @JsonProperty()
    declare aboutLink?: LinkConfiguration;

    /**
     * "über diese Karte" Link
     */
    @JsonProperty()
    declare helpLink?: LinkConfiguration;
    /**
     * legend
     */
    @JsonProperty()
    declare legend: LegendConfiguration;

    /**
     * Printing
     */
    @JsonProperty()
    declare print: PrintConfiguration;

    /**
     * Information about maintenance work on the application
     */
    @JsonProperty({ type: MaintenanceConfiguration})
    declare maintenance?: MaintenanceConfiguration[];

    // Objektabfrage Popup
    @JsonProperty()
    declare popup: PopupConfiguration;

    @JsonProperty({ type: SearchConfiguration})
    declare search: SearchConfiguration;

    @JsonProperty()
    declare tools: ToolsConfiguration;

    // Topics (Themen)
    @JsonProperty()
    declare topics: TopicConfiguration[];

    // Topics (Themen)
    @JsonProperty()
    declare subtopics?: TopicConfiguration[];

    @JsonProperty()
    declare topicSwitcher?: TopicSwitcherConfiguration;

    // Objektabfrage Highlight
    @JsonProperty()
    declare highlightSymbol: FillSymbolConfiguration;

    @JsonProperty()
    declare pointerSymbols?: HashMap<PictureMarkerSymbolConfiguration>;

    @JsonProperty()
    declare sidebar: SidebarConfiguration;

    @JsonProperty()
    declare tracker?: TrackerConfiguration;

    @JsonProperty()
    declare urls?: any;

    @JsonProperty()
    declare navigation: NavigationConfiguration;
    @JsonProperty()
    declare breadcrumbs: NavigationConfiguration;

    @JsonProperty()
    declare webMap: WebMapConfiguration;

    @JsonProperty()
    declare meta: WebMapMetaConfiguration;

    @JsonProperty()
    declare api_base_url: string;

    @JsonProperty()
    declare debug: boolean;
    /**
     * Enable or disable search field in locate button
     *
     * @default true
     */
    @JsonProperty()
        locateButtonEnabled = true;

    constructor() {
        super();
    }
    /**
     * Get first selectable subtopic (used when a parent topic is selected)
     *
     * @param topic
     * @param topics optional
     */
    getFirstSubtopic(topic: TopicConfiguration, topics: TopicConfiguration[] = []): TopicConfiguration {
        if (!this.topics.length && !topics.length) {
            throw new Error("No topics configured.");
        }
        if(topics.length === 0) {
            topics = this.topics;
        }
        const firstSubtopic = topics.find((item) => item.parentId === topic.id && item.routes);
        if (!firstSubtopic) {
            throw new Error("No subtopic for id "+topic.id+" found");
        }

        return firstSubtopic;
    }
}

